import styled from 'styled-components'

export const Container = styled.div` 
    display: flex;
    background-color: #f8f9fa;
    justify-content: space-between;
`